<div
  class="promotion-banner"
  [class.horizontal]="banner.layout === LayoutEnum.Horizontal"
  [class.vertical]="banner.layout === LayoutEnum.Vertical"
  [class.contained]="banner.layout === LayoutEnum.Contained"
  [style.--text-color]="textColor"
  [style.--color]="brandColor">
  <div class="content-wrapper">
    <div
      class="image-wrapper"
      *ngIf="banner.enableImage && (banner.imageUrl || banner.layout !== LayoutEnum.Contained)"
      [class.placeholder]="!banner.imageUrl">
      <img *ngIf="banner.imageUrl" [ngSrc]="banner.imageUrl" class="image" fill />
      <div *ngIf="banner.layout === LayoutEnum.Contained && banner.imageUrl" class="gradient-background"></div>
      <common-image-icon *ngIf="!banner.imageUrl" class="image-placeholder"></common-image-icon>
    </div>
    <div class="banner-text-wrapper">
      <div class="title">{{ banner.title }}</div>
      <div class="description">{{ banner.description }}</div>
    </div>
  </div>
  <a
    class="promotion-button"
    trackable="{{ contained ? 'Settings/' : '' }}Tracking page/{{ orderStatus }}/Announcement button"
    [class.disabled]="!banner.promotionButton.link"
    *ngIf="banner.enableButton && banner.promotionButton"
    [href]="banner.promotionButton.link"
    target="_blank"
    >{{ banner.promotionButton.text }}</a
  >
</div>
